import {
    List,
    EditButton,
    Datagrid,
    TextField,
    NumberField,
    Filter,
    RichTextField,
} from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import ThumbnailField from '../../common/ThumbnailField';
import useIsPermission from '../../hooks/useIsPermission';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';
import TestimonialCategoryAutoComplete from './TestimonialCategoryAutoComplete';

const ListFilter = (props: any) => (
    <Filter {...props}>
        <TestimonialCategoryAutoComplete alwaysOn />
    </Filter>
);

const TestimonialList = () => {
    const { isUpdatable, isWritable, isDeletable } = useIsPermission('TESTIMONIALS');

    return (
        <div>
            <List
                filters={<ListFilter />}
                actions={<PermissionBasedActions isWritable={isWritable} />}
            >
                <Datagrid bulkActionButtons={false}>
                    <ThumbnailField source="authorImage" />
                    <TextField source="authorName" />
                    <NumberField source="displayOrder" />
                    <RichTextField source="description" />
                    <FormattedDateTimeField source="createdAt" />
                    {isUpdatable && <EditButton />}
                    {isDeletable && <ConfirmDeleteButton />}
                </Datagrid>
            </List>
        </div>
    );
};
export default TestimonialList;
